// services/authService.js
import apis from "./Apis";
import {
  Get,
  Post,
  SecureGet,
  SecurePost,
  SecurePostMultipart,
} from "./axiosCall";

// Token Utilities
export const retriveToken = () => {
  const sessionToken = sessionStorage.getItem("Token");
  const localToken = localStorage.getItem("Token");

  // console.log("🔍 sessionToken:", sessionToken);
  // console.log("🔍 localToken:", localToken);

  return sessionToken || localToken;
};

export const storeToken = (token) => {
  const isRemembered = localStorage.getItem("isRememberMe") === "true";
  if (isRemembered) {
    localStorage.setItem("Token", token);
    localStorage.setItem("persistToken", "true");
  } else {
    sessionStorage.setItem("Token", token);
  }
};

export const deleteToken = () => {
  localStorage.removeItem("Token");
  localStorage.removeItem("isRememberMe");
  sessionStorage.removeItem("Token");
  localStorage.removeItem("type");
};

// API Functions
export const loginAuth = (email, password, type) =>
  Post({
    url: apis.LOGIN,
    data: { emailid: email, password, type },
  });

export const resetLogin = (email, url) =>
  Post({
    url: apis.FORGOT_PASSWORD,
    data: { email, url },
  });

export const resetPassword = (data) =>
  Post({
    url: apis.RESET_PASSWORD,
    data,
  });

export const fetchAuth = (token, subject) =>
  Get({
    url: apis.GETDETAILSUSER,
    params: {
      Token: token,
      subject: subject,
    },
  });

export const fetchSubjectTeacher = () => Get({ url: apis.GETDETAILTEACHER });

export const fetchStatistics = (token, subject) =>
  Get({
    url: apis.GETDETAILSUSERSTATISTICS,
    params: {
      Token: token,
      subject: subject,
    },
  });

export const fetchStatisticsComponent = (token, subject) =>
  Get({
    url: apis.GETDETAILSUSERSTATISTICSCOMPONENT,
    params: {
      Token: token,
      subject: subject,
    },
  });

export const generatePaper = (token,subject, topics, examType, formattedDate) =>
  Post({
    url: apis.GENERATEPAPER,
    data: {
      subject,
      topics,
      examType,
      testDate: new Date(),
      title: formattedDate,
    },
    params:{
      Token:token,
    }
  });

export const updateProfile = (data) =>
  SecurePost({
    url: apis.UPDATEPROFILE,
    data,
  });

export const uploadQuestionForConsultation = (data) =>
  SecurePostMultipart({
    url: apis.CONSULTATION_QUESTION,
    data,
  });

export const getQuestionForConsultation = () =>
  SecureGet({ url: apis.GET_CONSULTATION_QUESTION });

export const getAllCategory = () => SecureGet({ url: apis.GET_CATEGORY });

export const getAllReward = () => SecureGet({ url: apis.GET_REWARD });

export const getAllActiveOrders = () =>
  SecureGet({ url: apis.GET_ACTIVE_ORDER });

export const getAllPastOrders = () => SecureGet({ url: apis.GET_PAST_ORDER });

export const getRewardCategoryById = (id) =>
  SecureGet({ url: `${apis.GET_REWARD_CATEGORY}/${id}` });
